var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", {
    attrs: { title: _vm.cardTitle },
    scopedSlots: _vm._u([
      {
        key: "button",
        fn: function() {
          return [
            _c("Button", {
              attrs: { variant: "default" },
              on: { clicked: _vm.goBack },
              scopedSlots: _vm._u([
                {
                  key: "any",
                  fn: function() {
                    return [
                      _c("span", { staticClass: "flex items-center gap-2" }, [
                        _c("i", { staticClass: "fas fa-chevron-left" }),
                        _vm._v("\n        Back\n      ")
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function() {
          return [
            _c("div", { staticClass: "w-full" }, [
              _c(
                "ul",
                {
                  staticClass:
                    "flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row"
                },
                [
                  _c(
                    "li",
                    {
                      staticClass:
                        "-mb-px mr-2 last:mr-0 flex-auto text-center cursor-pointer "
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            " text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal",
                          class: {
                            "text-blue-500 bg-white": _vm.openTab !== 1,
                            "text-white bg-blue-500": _vm.openTab === 1
                          },
                          on: {
                            click: function($event) {
                              return _vm.toggleTabs(1)
                            }
                          }
                        },
                        [_vm._v("\n            Videos\n          ")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass:
                        "-mb-px mr-2 last:mr-0 flex-auto text-center cursor-pointer "
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal",
                          class: {
                            "text-blue-500 bg-white": _vm.openTab !== 2,
                            "text-white bg-blue-500": _vm.openTab === 2
                          },
                          on: {
                            click: function($event) {
                              return _vm.toggleTabs(2)
                            }
                          }
                        },
                        [_vm._v("\n            Playlists\n          ")]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded"
                },
                [
                  _c("div", { staticClass: "px-4 py-5 flex-auto" }, [
                    _c("div", { staticClass: "tab-content tab-space" }, [
                      _c(
                        "div",
                        {
                          staticClass: "mx-400 overflow-y-auto",
                          class: {
                            hidden: _vm.openTab !== 1,
                            block: _vm.openTab === 1
                          }
                        },
                        [
                          _vm.channel
                            ? _c("TabVideos", {
                                ref: "tab-videos",
                                attrs: { channel: _vm.channel }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "mx-400 overflow-y-auto",
                          class: {
                            hidden: _vm.openTab !== 2,
                            block: _vm.openTab === 2
                          }
                        },
                        [
                          _vm.channel
                            ? _c("TabPlaylist", {
                                attrs: { channel: _vm.channel }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ])
                ]
              )
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c9d02b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c9d02b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/MissionsVideos/Channel/ChannelDetail.vue
// module id = null
// module chunks = 